import {
    ChangeDetectorRef,
    Component,
    Input,
    NgZone,
    signal,
} from "@angular/core";
import { Task } from "src/app/core/models/task";
import { IconButtonComponent } from "../../../shared-ui/icon-button/icon-button.component";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import {
    NgbActiveModal,
    NgbDate,
    NgbDateParserFormatter,
    NgbInputDatepicker,
    NgbTooltip,
    NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { DatePipe, JsonPipe, LowerCasePipe, NgClass } from "@angular/common";
import { ContentTranslaterComponent } from "../../../shared-ui/content-translater/content-translater.component";
import { DateFormatEnum } from "src/app/core/helpers/date-format-enum";
import { ConsultantRole } from "src/app/core/models/consultant-role";
import { CommonDataService } from "src/app/core/api/common-data.service";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ValidationFormApiService } from "src/app/core/api/validation-form-api.service";
import { ValidationFormGet } from "src/app/core/models/validation-form-get";
import { ProfileApiService } from "src/app/core/api/profile-api.service";
import { ProfilePersonalData } from "src/app/core/models/profile-personal-data";
import { ValidationFormFields } from "src/app/core/models/validation-form-fields";
import { InputTypeEnum } from "src/app/core/models/enum/input-type-enum";
import { ValidationFormAnswer } from "src/app/core/models/validation-form-answer";
import { NgbDateCustomParserFormatter } from "src/app/core/Util/ngb-date-parser-customer-formatter";
import { ValidationFormReference } from "src/app/core/models/validation-form-reference";
import { InputButtonComponent } from "../../../shared-ui/input-button/input-button.component";
import { ProfileImageComponent } from "../../../shared-ui/profile-image/profile-image/profile-image.component";
import { RatingBarComponent } from "../../../shared-ui/rating-bar/rating-bar.component";
import { ValidationModalTaskDetailsComponent } from "../../../tasks/components/validation-modal-task-details/validation-modal-task-details.component";
import { ValidationFormAnswerPost } from "src/app/core/models/validation-form-answer-post";
import { ValidationFormAnswerStateEnum } from "src/app/core/models/enum/validation-form-answer-state-enum";
import { convertToDate, convertToDateString } from "src/app/core/Util/util";
import { AuthenticationService } from "src/app/core/services/authentiation.service";
import { User } from "src/app/core/models/user";
import { ActivatedRoute, Router } from "@angular/router";
import { ValidationFormTokenAccess } from "src/app/core/models/validation-form-token-access";
import { ToastrService } from "ngx-toastr";
import { UserRoleEnum } from "src/app/core/models/enum/user-role-enum";
import { send } from "process";
import {
    QuillModules,
    QuillModule,
    QuillToolbarConfig,
    QuillViewComponent,
} from "ngx-quill";
import { SpinnerService } from "src/app/core/services/spinner.service";


@Component({
    selector: "app-validation-form-answer-modal",
    standalone: true,
    imports: [
        IconButtonComponent,
        TranslatePipe,
        DatePipe,
        NgClass,
        ContentTranslaterComponent,
        ReactiveFormsModule,
        FormsModule,
        NgbInputDatepicker,
        InputButtonComponent,
        ProfileImageComponent,
        RatingBarComponent,
        ValidationModalTaskDetailsComponent,
        NgbTooltip,
        NgbTooltipModule,
        QuillViewComponent,
        JsonPipe,
        LowerCasePipe,
        QuillModule
    ],
    templateUrl: "./validation-form-answer-modal.component.html",
    styleUrl: "./validation-form-answer-modal.component.scss",
    providers: [
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateCustomParserFormatter,
        },
    ],
})
export class ValidationFormAnswerModalComponent {
    @Input() taskId: number;
    @Input() profileId: number;
    @Input() profileIdFromUrl: number;

    public taskAssociatedToValidationForm: Task = {} as Task;
    public seeOverview: boolean = false;
    public currentPage: number = 1;
    public dateFormatEnum = DateFormatEnum;
    public consultantRoles: ConsultantRole[] = [];
    public consultantForTask: ConsultantRole;
    public validationAnswerForm: FormGroup;
    public validationForm: ValidationFormGet;
    public profileInfo: Pick<
        ProfilePersonalData,
        "email" | "firstname" | "surname" | "jobTitle" | "imagePath"
    > = {} as Pick<
        ProfilePersonalData,
        "email" | "firstname" | "surname" | "jobTitle" | "imagePath"
    >;
    public generalFormFields: Omit<ValidationFormFields, "source">[];
    public ratingFormFields: Omit<ValidationFormFields, "source">[];
    public inputTypeEnum = InputTypeEnum;
    public validationFormAnswersGet: ValidationFormAnswer;
    public allAnswersForValidation: { fieldId: number; value: string }[] = [];
    public allRatingAnswers: { fieldId: number; value: number }[] = [];
    public answersByFieldId: { [key: number]: string | Date | number } = {};
    public ratingAnswersByFieldId: { [key: number]: number } = {};
    public isEditingReference = false;
    public categories = [];
    public file: any;
    public editingIndex?: number;
    public selectedReference: number;
    public referencesList: Omit<
        ValidationFormReference,
        "id" | "validationFormAnswerId"
    >[] = [];
    public referenceById: Omit<
        ValidationFormReference,
        "id" | "validationFormAnswerId"
    >;
    public showReferenceForm = false;
    public hideAddReferenceBtn = false;
    public referenceForm: Omit<
        ValidationFormReference,
        "id" | "validationFormAnswerId"
    > = {
        name: "",
        mail: "",
        phone: "",
        description: "",
    };

    public paymentConditions: string | null;
    public paymentConditionsAccepted = true;
    public personalMotivation = "";
    public validationFormId;
    public answersMapped = {};
    public currentUser: User;
    public accessToken: ValidationFormTokenAccess;
    public accessTokenEmail: string;
    public accessTokenName: string;
    public editImage: boolean = false;
    public accessTokenImageFile: string | null = null;
    public referenceValidation = false;
    public currentAnswer: string | Date | number | null = null;
    public uploadedImagePath: string | null = null;
    public selectedImagePath: string | null = null;
    public ValidationFormAnswerStateEnum = ValidationFormAnswerStateEnum;
    public UserRoleEnum = UserRoleEnum;
    public validationFormLang = signal<string>("en");
    private allValidationFormFields: ValidationFormFields[] = [];

    private consultantLabeltranslations = {
        en: {
            validationModalTitle: "Validation form",
            taskDetails: "Task details",
            general: "General",
            assessment: "Assessment",
            references: "References",
            customer: "Customer",
            role: "Role",
            startDate: "Start date",
            timePerWeek: "Hours p/week",
            location: "Location",
            languageRequirement: "Language requirement",
            endDate: "End date",
            taskDescription: "Task description",
            paymentConditions: "Payment conditions",
            accept: "Accept",
            decline: "Decline",
            email: "Email",
            name: "Name",
            picture: "Picture",
            uploadNewPicture: "Choose file",
            personalMotivation: "Your personal motivation",
            back: "Back",
            next: "Next",
            qualities: "Personal",
            experience: "Experience",
            addReferences: "Add reference",
            phone: "Phone",
            description: "Description",
            cancel: "Cancel",
            confirm: "Confirm",
            validationForm: "Validation form",
            writeHere: "Write here...",
            summary: "Summary",
            send: "Send",
            personalMotivationPlaceholder:
                "Please write your motivation towards the requirements (next page) - If you have similar experience from other clients, please refer to the projects listed in your KOLLAB CV.",
            yes: "Yes",
            no: "No",
            referenceDescription: "Description of the relation",
            experienceToolTip: "Businesss & Technical skills",
            qualitiesToolTip: "Personal skills",
            confirmSend: "Are you sure you want to send the validation form?",
            validationFormSendSuccessTitle:
                "Thank you for completing the validation form!",
            validationFormSendText:
                "We have received your validation form and will get back to you as soon as possible.",
            validationFormSendTip:
                "PRO TIP: In the meantime, you can ensure your profile is razor-sharp by updating or completing remaining fields on your profile.",
            validationFormAnswerSent: "Validation form has been sent",
            uploadImageSuccess: "Image has been uploaded",
            competenceRequirements: "Requirements for competences",
        },
        da: {
            validationModalTitle: "Valideringsformular",
            taskDetails: "Opgavedetaljer",
            general: "Generelt",
            assessment: "Vurdering",
            references: "Referencer",
            customer: "Kunde",
            role: "Rolle",
            startDate: "Startdato",
            timePerWeek: "Timer pr.uge",
            location: "Lokation",
            languageRequirement: "Sprog krav",
            endDate: "Slutdato",
            taskDescription: "Opgavebeskrivelse",
            paymentConditions: "Betalingsbetingelser",
            accept: "Accepter",
            decline: "Accepter ikke",
            email: "Mail",
            name: "Navn",
            picture: "Billede",
            uploadNewPicture: "Vælg fil",
            personalMotivation: "Din personlige motivation",
            back: "Tilbage",
            next: "Næste",
            qualities: "Personlighed",
            experience: "Erfaring",
            addReferences: "Tilføj reference",
            phone: "Telefon",
            description: "Beskrivelse",
            cancel: "Annuller",
            confirm: "Bekræft",
            validationForm: "Valideringsformular",
            writeHere: "Skriv her...",
            summary: "Opsumering",
            send: "Send",
            personalMotivationPlaceholder:
                "Skriv venligst din motivation i forhold til kravene (næste side) - Hvis du har lignende erfaring fra andre kunder, henvis venligst til projekterne, der er angivet i dit KOLLAB CV.",
            yes: "Ja",
            no: "Nej",
            referenceDescription: "Beskrivelse af relationen",
            experienceToolTip: "Tekniske og forretningsmæssige færdigeder",
            qualitiesToolTip: "Personlige færdigheder",
            confirmSend:
                "Er du sikker på, at du vil indsende valideringsformularen?",
            validationFormSendSuccessTitle: "Tak for at udfylde valideringen!",
            validationFormSendText:
                "Vi har modtaget din valideringsform og gennemgår den nu. Du hører snart fra os!",
            validationFormSendTip:
                "PRO TIP: I mellemtiden kan du sikre at din profil står kniv-skarpt ved at opdatere eller udfylde resterende felter på din profil.",
            validationFormAnswerSent: "Valideringsform er sendt",
            uploadImageSuccess: "Billedet er uploadet",
            personalMotivationError: "Skriv venligst din motivation",
            competenceRequirements: "Krav til kompetencer",
        },
    };

    getConsultantLabel(key: string) {
        if (this.validationForm?.lang) {
            return this.consultantLabeltranslations[this.validationForm.lang][
                key
            ];
        }
    }

    public get modules(): QuillModules {
        return {
            toolbar: this.toolbar,
        };
    }
    private get toolbar(): QuillToolbarConfig {
        return [
            ["bold", "italic"],
            [{ list: "bullet" }, { list: "ordered" }],
        ];
    }

      yearOptionsMap = {
        "0": "0",
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
        "6": "5+",
        "11": "10+",
        "21": "20+",
    };

    getYearDisplayValue(value: string | null): string {
        if (value === null) {
            return;
        }
        return this.yearOptionsMap[value];
    }

    modifiedAnswers: { [key: number]: any } = {};

    onValueChange(field: Omit<ValidationFormFields, "source">, value: any) {
        this.answersByFieldId[field.id] = value;

        let modifiedValue = value;
        if (field.inputType === InputTypeEnum.Text) {
            if (value === "true") modifiedValue = "'true'";
            if (value === "false") modifiedValue = "'false'";
        }

        if (field.inputType === InputTypeEnum.DatePicker) {
            modifiedValue = `${String(value.day).padStart(2, "0")}-${String(
                value.month
            ).padStart(2, "0")}-${value.year}`;
        }
        if (field.inputType === InputTypeEnum.RadioButton) {
            modifiedValue = value.toString();
        }

        this.modifiedAnswers[field.id] = modifiedValue;
    }

    getCompleteModifiedAnswers() {
        return { ...this.answersByFieldId, ...this.modifiedAnswers };
    }
    constructor(
        public activeModal: NgbActiveModal,
        public commonDataService: CommonDataService,
        public validationFormApiService: ValidationFormApiService,
        private profileApiService: ProfileApiService,
        private authService: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router,
        private translateService: TranslateService,
        private toastr: ToastrService,
        private cd: ChangeDetectorRef,
        private spinner: SpinnerService
    ) {}

    public ngOnInit() {
        this.authService.currentUser.subscribe((user) => {
            this.currentUser = user;
        });

        if (!this.currentUser) {
            const token = this.route.snapshot.queryParams["token"];
            this.validationFormApiService
                .getAccessToken(token)
                .subscribe((tokenAccess) => {
                    this.accessTokenEmail = tokenAccess.email;
                    this.accessToken = tokenAccess;

                    if (this.accessToken.used) {
                        this.router.navigate(["/login"]);
                    }
                });
        }

        this.commonDataService.getConsultantRoles().subscribe((result) => {
            this.consultantRoles = result;
            this.loadTaskData();
        });

        if (this.currentUser.userRoleEnumDto === UserRoleEnum.Profile) {
            this.loadProfileInfo(this.currentUser.profileId);
        } else if (this.currentUser.userRoleEnumDto === UserRoleEnum.Admin) {
            const urlSegments = this.router.url.split("?")[0].split("/");
            const profileId = +urlSegments[urlSegments.indexOf("edit") + 1];
            if (profileId) {
                this.loadProfileInfo(profileId);
            }
        }
    }

    private loadData(validationFormId: number) {
        this.validationFormApiService
            .getTaskDetailsByValidationFormId(validationFormId)
            .subscribe((result: any) => {
                if (!result) return;

                this.taskAssociatedToValidationForm = result;

                if (this.consultantRoles && result.consultantRoleId) {
                    this.consultantForTask = this.consultantRoles.find(
                        (role) => role.id === result.consultantRoleId
                    );
                }

                // this.loadValidationFormData();
                if (this.validationForm) {
                    this.processFormFields(this.validationForm);
                }
            });
    }

    private loadValidationFormData(validationFormId: number) {
        if (!validationFormId) return;

        this.validationFormApiService
            .getValidationFormById(validationFormId)
            .subscribe((result) => {
                this.validationForm = result;
                this.allValidationFormFields = this.validationForm.validationFormFields || [];

                this.generalFormFields =
                    result.validationFormFields?.filter(
                        (item) => item.fieldType === "generalField"
                    ) || [];
                this.ratingFormFields =
                    result.validationFormFields?.filter(
                        (item) => item.fieldType === "ratingField"
                    ) || [];


                this.categories = Array.from(
                    new Set([
                        ...this.ratingFormFields.map((item) => item.category),
                    ])
                );
                this.paymentConditions = result.paymentDetails || null;
            });
    }

  private processFormFields(result: ValidationFormGet) {
    const isAdmin = this.currentUser.userRoleEnumDto === UserRoleEnum.Admin;
    const isConsultant = this.currentUser.userRoleEnumDto === UserRoleEnum.Profile;

    // this.allValidationFormFields = result.validationFormFields || [];


    this.generalFormFields = (
        result.validationFormFields?.filter(
            (item) =>
                item.fieldType === "generalField" &&
                // If Admin → show all fields (ignore showToConsultant)
                // If Consultant → only show fields where showToConsultant === true
                (isAdmin || !isConsultant || item.showToConsultant === true)
        ) || []
    ).map((item) => {
        if (
            item.fieldId === 2 &&
            this.taskAssociatedToValidationForm?.location
        ) {
            return {
                ...item,
                name: `${item.name} ${this.taskAssociatedToValidationForm.location}`,
            };
        }
        return item;
    });
}

    private loadProfileInfo(profileId: number) {
        this.profileApiService.get(profileId).subscribe((result) => {
            this.profileInfo = {
                email: result.email,
                firstname: result.firstname,
                surname: result.surname,
                jobTitle: result.jobTitle,
                imagePath: result.imagePath,
            };
            this.selectedImagePath = result.imagePath || null;
            this.cd.detectChanges();
        });
    }

    private loadTaskData() {
        this.spinner.show();
        this.validationFormApiService
            .getByTaskId(this.taskId)
            .subscribe((result) => {
                this.validationFormId = result.id;
                this.loadData(this.validationFormId);
                this.loadValidationFormData(this.validationFormId);
            });
            this.spinner.hide();
    }

    //Dynamically change the modal size on page 2 onwards
    updateModalSize(size: "modal-sm" | "modal-lg" | "modal-xl") {
        const modalDialog = document.querySelector(".modal-dialog");
        if (modalDialog) {
            modalDialog.classList.remove("modal-sm", "modal-lg", "modal-xl");
            modalDialog.classList.add(size);
        }
    }

    public onSelectFile(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files?.length) return;
        const file = input.files[0];

        this.validationFormApiService.uploadAnswerImage(file).subscribe({
            next: (imagePath: string) => {
                this.selectedImagePath = imagePath;

                // this.translateService.get('validationForm.toastrMsgs.uploadImageSuccess', {fileName: file.name}).subscribe((res: string) => {
                //     this.toastr.success(res || `Image '${file.name}' uploaded successfully.`);
                // });
                const message = this.getConsultantLabel("uploadImageSuccess");
                if (message) {
                    this.toastr.success(message);
                }
                // this.cd.detectChanges();
            },
            error: (err) => {
                console.error("onSelectFile: Image upload failed: ", err);
                this.translateService
                    .get("validationForm.toastrMsgs.uploadImageError")
                    .subscribe((res: string) => {
                        this.toastr.error(
                            res || "Image upload failed. Please try again."
                        );
                    });
            },
        });
    }

    setRating(field: any, rating: number) {
        this.answersByFieldId[field.id] = rating;
    }

    public editProfileImage() {
        this.editImage = true;
    }

    gotoPreviousPage(): void {
        if (this.currentPage > 1) {
            if (this.currentPage === 2) {
                this.updateModalSize("modal-lg");
            }
            if (this.currentPage === 6) {
                this.updateModalSize("modal-xl");
            }
            this.currentPage--;
        }
    }

    goToNextPage() {
        // Special validation for page 2
        if (this.currentPage === 2) {
            let isValid = true;

            if (this.accessToken) {
                if (this.accessTokenName.trim() === "") {
                    isValid = false;
                }
            }

            if (this.personalMotivation.trim() === "") {
                isValid = false;
                     const message = this.getConsultantLabel(
                                    "personalMotivationError"
                                );
                                if (message) {
                                    this.toastr.error(message);
                                }

            }

            if (!isValid) {
                return;
            }
        }

        // Proceed to next page if validation passes or not on page 2
        if (this.currentPage < 7) {
            this.currentPage++;
            // Set modal size to xl from page 2 onwards
            if (this.currentPage >= 2) {
                this.updateModalSize("modal-xl");
            }
        }
    }
    public handleShowReferenceForm() {
        this.showReferenceForm = true;
        this.hideAddReferenceBtn = true;
    }

    handleSaveReferences() {
        if (this.editingIndex !== undefined) {
            this.referencesList[this.editingIndex] = {
                name: this.referenceForm.name,
                mail: this.referenceForm.mail,
                phone: this.referenceForm.phone,
                description: this.referenceForm.description,
            };
            this.editingIndex = undefined;
        } else {
            if (
                this.referenceForm.name == "" ||
                (this.referenceForm.mail == "" &&
                    this.referenceForm.phone == "")
            ) {
                this.referenceValidation = true;
                //The toastr is not working on token
                // this.toastr.error("validationForm.toastrMsgs.referenceValidation");
                return;
            }
            this.referencesList.push({
                name: this.referenceForm.name,
                mail: this.referenceForm.mail,
                phone: this.referenceForm.phone,
                description: this.referenceForm.description,
            });
        }

        this.showReferenceForm = false;
        this.referenceForm = {
            name: "",
            mail: "",
            phone: "",
            description: "",
        };
        this.hideAddReferenceBtn = false;
        this.isEditingReference = false;
        this.referenceValidation = false;
    }

    public saveReferences() {}

    get transformAnswersToLabelValuePairs(): Array<{
        id: number;
        label: string;
        value: any;
        isRating: boolean;
        inputType: InputTypeEnum;
    }> {
        const allFields = [...this.generalFormFields, ...this.ratingFormFields];

        return Object.entries(this.getCompleteModifiedAnswers()).map(
            ([fieldId, value]) => {
                const field = allFields.find((f) => f.id === +fieldId);
                let transformedValue: string | any = value;

                if (typeof value === "boolean") {
                    if (this.validationForm.lang === "en") {
                        // English
                        transformedValue = value ? "Yes" : "No";
                    } else {
                        // Danish
                        transformedValue = value ? "Ja" : "Nej";
                    }
                }

                return {
                    id: +fieldId,
                    label: field?.name,
                    value: transformedValue,
                    isRating: field?.category !== null,
                    inputType: field?.inputType,
                };
            }
        );
    }

    get summaryGeneralInfo() {
        return this.transformAnswersToLabelValuePairs.filter(
            (answer) => answer.isRating === false
        );
    }

    get summaryRatingInfo() {
        return this.transformAnswersToLabelValuePairs.filter(
            (answer) => answer.isRating === true
        );
    }
    editReference(reference: any, index: number) {
        this.referenceForm = { ...reference };
        this.editingIndex = index;
        this.selectedReference = index;
        this.isEditingReference = true;
        this.showReferenceForm = true;
        this.hideAddReferenceBtn = true;
    }

    cancelEditing() {
        this.showReferenceForm = false;
        this.referenceForm = {
            name: "",
            mail: "",
            phone: "",
            description: "",
        };
        this.editingIndex = undefined;
        this.hideAddReferenceBtn = false;
        this.isEditingReference = false;
        this.referenceValidation = false;
    }

    public deleteReference(reference, index) {
        this.referencesList = this.referencesList.filter(
            (ref, ind) => ind !== index
        );
    }

    sendValidationFormAnswers() {
        this.updateModalSize("modal-lg");
        this.currentPage = 6;
    }

    public getTranslations(key: string) {}

    public confirmSend() {
        this.currentPage = 7;

        const allAnswerFields = Object.entries(
            this.getCompleteModifiedAnswers()
        ).map(([key, value]) => {
            let finalAnswer = value ?? "";
            if (value && typeof value === "object" && "year" in value) {
                finalAnswer = convertToDate(value as unknown as NgbDate);
            } else {
                finalAnswer = value?.toString() || "";
            }
            return {
                ValidationFormFieldId: Number(key),
                answer: finalAnswer,
            }
        });

        const completeAnswerPayload = this.allValidationFormFields.map(masterField => {
            const answeredField = allAnswerFields.find(
                ans => ans.ValidationFormFieldId === masterField.id
            );
            return {
                validationFormFieldId: masterField.id,
                answer: answeredField ? answeredField.answer : "",
        }
        });

        const userId = this.currentUser
            ? this.currentUser.userRoleEnumDto === UserRoleEnum.Profile
                ? this.currentUser.id
                : this.currentUser.userRoleEnumDto === UserRoleEnum.Admin
                ? +this.route.snapshot.queryParams["userId"]
                : null
            : null;

        const validationAnswers: ValidationFormAnswerPost = {
            email: this.profileInfo.email || this.accessTokenEmail,
            name: this.profileInfo.firstname
                ? `${this.profileInfo.firstname} ${this.profileInfo.surname}`.trim()
                : this.accessTokenName?.trim() || "",
            imagePath:
                this.selectedImagePath ?? this.profileInfo.imagePath ?? "",
            motivation: this.personalMotivation,
            paymentAccepted: this.paymentConditionsAccepted,
            validationFormFieldAnswers: completeAnswerPayload,
            state: ValidationFormAnswerStateEnum.Answered,
            references: this.referencesList,
            validationFormId: this.validationFormId,
            userId: userId,
        };

        this.validationFormApiService
            .validationFormAnswerPost(validationAnswers)
            .subscribe((res: { answerId: number; user: User }) => {
                if (!this.currentUser) {
                    localStorage.setItem(
                        "currentUser",
                        JSON.stringify(res.user)
                    );
                    this.authService["currentUserSubject"].next(res.user);

                    const checkUserInterval = setInterval(() => {
                        if (this.authService.currentUserValue) {
                            clearInterval(checkUserInterval);
                            if (this.accessToken) {
                                const message = this.getConsultantLabel(
                                    "validationFormAnswerSent"
                                );
                                if (message) {
                                    this.toastr.success(message);
                                }
                            }
                            this.router.navigate(["/edit-my-profile-page"]);
                        }
                    }, 100);
                } else {
                    if (res.answerId) {
                        this.updateModalSize("modal-lg");
                        this.currentPage = 7;
                    }
                }
            });
    }
}
